import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setGlobalLoader } from '../redux/reducers/utils/commonReducer';

/**
 * Хук для управления глобальным индикатором загрузки
 * Отслеживает состояние различных запросов и управляет показом лоадера
 */
const useGlobalLoader = () => {
  const dispatch = useDispatch();
  const { 
    giveRoleToNewUserRequestStatus, 
    userProfileRequestStatus 
  } = useSelector((store) => store.auth);
  const { 
    accessGetComponentsForUserRequestStatus 
  } = useSelector((store) => store.services);

  useEffect(() => {
    const isLoading = (
      giveRoleToNewUserRequestStatus === 'pending' ||
      userProfileRequestStatus === 'pending' ||
      accessGetComponentsForUserRequestStatus === 'pending'
    );

    dispatch(setGlobalLoader(isLoading));
  }, [
    giveRoleToNewUserRequestStatus,
    userProfileRequestStatus,
    accessGetComponentsForUserRequestStatus,
    dispatch,
  ]);
};

export default useGlobalLoader;
